export default "__VITE_ASSET__CGtWhdyT__"